import React, {Component} from 'react';
import {Container, Grid, Header, Icon, Menu} from 'semantic-ui-react';


class Social extends Component {
    render() {
        return (
            <a href={this.props.href} target='_blank' rel='noopener noreferrer'>
                <Icon name={this.props.name} size='huge' style={{color: '#777777'}}/>
            </a>
        );
    }
}

class Footer extends Component {
    render() {
        return (
            <Menu attached='bottom' style={{backgroundColor: '#F5F5F5'}}>
                <Container>
                    <Grid centered stackable style={{padding: 40}}>
                        <Grid.Column mobile={16} tablet={4} computer={4}>
                            <Header>
                                About Us
                            </Header>
                            <p>
                                We are an open source project striving to make apps that benefit the community.
                            </p>
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={4} computer={4}>
                            <Header>
                                Social
                            </Header>
                            <Social name='twitter' href="https://twitter.com/openevo"/>
                            <Social name='facebook' href="https://www.facebook.com/openevo/"/>
                            <Social name='github' href='https://github.com/openevo'/>
                            <Social name='youtube' href='https://www.youtube.com/channel/openevo'/>
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={4} computer={4}>
                            <Header>
                                More Info
                            </Header>
                            <p>Here is more info</p>
                            <p>© 2018 Openevo, Inc.</p>
                        </Grid.Column>
                    </Grid>
                </Container>
            </Menu>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.js